export default __webpack_public_path__ + "static/media/datatypes.dfcd7f88.gif";